import { Loader } from '@ui-component-library/components/Loader';

import { Icon } from '../../Icon';

import type { SuffixIconProps } from './SuffixIcon.types';

import { S } from './SuffixIcon.styles';

export const SuffixIcon = ({
  isTyping,
  isFocused,
  validationState,
  handleClear
}: SuffixIconProps) => {
  if (isTyping) {
    return (
      <S.IconWrapper>
        <Loader />
      </S.IconWrapper>
    );
  }

  if (isFocused) {
    return (
      <S.Button
        type="button"
        onClick={handleClear}
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
      >
        <Icon name="CrossFilled" size="medium" color="charcoal-500" />
      </S.Button>
    );
  }

  if (validationState === 'success') {
    return (
      <S.IconWrapper>
        <Icon name="CheckFilled" size="medium" color="success-500" />
      </S.IconWrapper>
    );
  }

  if (validationState === 'error') {
    return (
      <S.IconWrapper>
        <Icon name="ExclamationFilled" size="medium" color="danger-500" />
      </S.IconWrapper>
    );
  }

  return null;
};
